import {
  Box,
  Button,
  Grid,
  InputLabel,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import {
  DetailsUI,
  EmployeeRequest,
  ProfileUI,
} from "../BoxUI";
import BarChart from "../charts/barChart";
import LineChart from "../charts/lineChart";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { CustomInput, CustomSelect } from "../UIElements/input-verification";
import {
  RegisterOptions,
  FieldValues,
  UseFormRegisterReturn,
} from "react-hook-form";
import { InputCustomSize } from "../UIElements/input-ui";
import SelectInput from "../UIElements/select";
import AddHospitalForm from "./AddHospitalForm";
import AllJobApplication from "./AllJobApplication";

import PreviewForm from "./PreviewForm";
import { PostJobProps } from "../../interface/job_board";
import dayjs, { Dayjs } from "dayjs";
import { useAuth } from "../../hooks/useAuth";

const AddHospitalContent = () => {
  const theme = useTheme();
  const { token } = useAuth();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const [type, setType] = useState("Public");

  const [preview, setPreview] = useState(true);
  const headerSty = {
    fontFamily: "Lexend",
    fontWeight: 500,
    my: isMedium ? 2 : 3,
    color: theme.palette.neutral.light,
  };
  const btnSty = {
    paddingY: 2,
    paddingX: 4,
    fontFamily: "DM Sans",
    fontWeight: 700,
    fontSize: "12px",
    borderRadius: "12px",
    "&: hover": {
      background: "inherit",
    },
  };
  
  const [job_details, setJob_Details] = useState<PostJobProps>({
    job_title: "",
    work_location: "",
    job_description: "",
    how_to_apply: "",
    application_deadline: "",
    experience_level: "",
    work_schedule: "",
    job_type: "",
    department: "",
    qualifications: "",
    employment_type: "",
    work_type: "",
    contract_duration: "",
    additional_info: "",
  });
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [documents, setDocuments] = useState<string[]>([]);
  const [salary_range, setSalary_Range] = useState<{
    min: string;
    max: string;
  }>({ min: "", max: "" });

  const handleDocument = (event: SelectChangeEvent<typeof documents>) => {
    const {
      target: { value },
    } = event;
    setDocuments(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleDateChange = (newValue: Dayjs) => {
    if (!newValue) return;

    setSelectedDate(newValue);
  };

  const handlePreview = () => {
    setPreview(!preview);
  };
  return (
    <Stack sx={{ paddingX: 2, width: isMedium ? "100%" : "90%" }}>
      <Box
        sx={{
          margin: 2,
          padding: isMedium ? 3 : 4,
          borderRadius: "3px",
          minHeight: "50vh",
          marginTop: 3,
          backgroundColor: theme.palette.common.white,
        }}
      >
        {preview && (
          <Box>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography
                sx={{ ...headerSty, my: 0, mb: 2 }}
                variant="subtitle2"
              >
                Add Hospital
              </Typography>
              <Button
                onClick={handlePreview}
                sx={{ borderRadius: "12px", width: 120 }}
                variant="contained"
              >
                Preview
              </Button>
            </Stack>
            <Typography variant="subtitle2" sx={{ ...headerSty }}>
              Hospital Type
            </Typography>
            <Box display={"flex"}>
              <Stack
                direction={"row"}
                sx={{
                  gap: 1,
                  background: "#284CB133",
                  p: 1,
                  borderRadius: "12px",
                  my: 2,
                  mb: 2
                }}
              >
                <Button
                  sx={{
                    ...btnSty,
                    color: type === "Public" ? "#fff" : "#1E1E1E",
                    background:
                      type === "Public" ? theme.palette.primary.main : "",
                  }}
                  onClick={() => setType("Public")}
                >
                  Public
                </Button>
                <Button
                  sx={{
                    ...btnSty,
                    color: type === "Private" ? "#fff" : "#1E1E1E",
                    background:
                      type === "Private" ? theme.palette.primary.main : "",
                  }}
                  onClick={() => setType("Private")}
                > 
                  Private
                </Button>
              </Stack>
            </Box>
            <AddHospitalForm
              jobDetails={job_details}
              changeJobDetails={setJob_Details}
              changeSelectDate={handleDateChange}
              document={documents}
              salary={salary_range}
              handleSalary={setSalary_Range}
              handleDocumentChange={handleDocument}
              selectDate={selectedDate}
            />{" "}
          </Box>
        )}
        {!preview && (
          <PreviewForm
            date={selectedDate}
            documents={documents}
            salary={salary_range}
            data={job_details}
            type={type}
          />
        )}
      </Box>
    </Stack>
  );
};

export default AddHospitalContent;
